
export const sortAlphabetically = (data, key = "name") => {
  return data.sort((a, b) => (a[key] || "").toString().localeCompare((b[key] || "").toString()))
}

export const sortUsers = (value) => {
  return [
    ...value
      ?.filter((item) => item?.analytics)
      .sort((a, b) =>
        a.analytics?.event_timestamp < b.analytics?.event_timestamp
          ? 1
          : a.analytics?.event_timestamp > b.analytics?.event_timestamp
          ? -1
          : 1,
      ),
    ...value.filter((item) => !item?.analytics),
  ]
}
